module.exports = __webpack_public_path__ + "static/img/section5_content1_bg1.bf61cf12.png";